import React from "react";
import { Tabs } from "@material-ui/core";
import cx from "classnames";
import { useVerticalTabsStyles } from "./useVerticalTabsStyles";

type VerticalTabsProps = Parameters<typeof Tabs>[0];

export const VerticalTabs = (props: VerticalTabsProps) => {
    const classes = useVerticalTabsStyles();

    const { className: originalClassName, ...otherProps } = props;
    const className = cx(classes.tabsRoot, originalClassName);

    return <Tabs orientation="vertical" className={className} {...otherProps} />;
};
